// src/components/Resume/TXTDownload.jsx
import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { Button } from 'react-bootstrap';
import toast from 'react-hot-toast';

const TXTDownload = ({ formData, coverLetterData }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    setLoading(true);
    try {
      const lines = [];

      // Header
      lines.push(formData.full_name || 'Your Name');
      lines.push(formData.title || '');
      if (formData.email) lines.push(`Email: ${formData.email}`);
      if (formData.phone) lines.push(`Phone: ${formData.phone}`);
      if (formData.address) lines.push(`Location: ${formData.address}`);
      lines.push('');

      // Summary
      if (formData.summary) {
        lines.push('PROFESSIONAL SUMMARY');
        lines.push('-'.repeat(40));
        lines.push(formData.summary);
        lines.push('');
      }

      // Experience
      if (formData.experience && formData.experience.length > 0) {
        lines.push('WORK EXPERIENCE');
        lines.push('-'.repeat(40));
        formData.experience.forEach((exp) => {
          lines.push(`${exp.title || ''} at ${exp.company || ''}`);
          lines.push(`${exp.startDate || ''} - ${exp.endDate || 'Present'}`);
          if (exp.description) lines.push(exp.description);
          lines.push('');
        });
      }

      // Education
      if (formData.education && formData.education.length > 0) {
        lines.push('EDUCATION');
        lines.push('-'.repeat(40));
        formData.education.forEach((edu) => {
          lines.push(`${edu.degree || ''} - ${edu.institution || ''} (${edu.year || ''})`);
        });
        lines.push('');
      }

      // Skills
      if (formData.skills && formData.skills.length > 0) {
        lines.push('SKILLS');
        lines.push('-'.repeat(40));
        lines.push(formData.skills.map(s => typeof s === 'string' ? s : s.name).join(', '));
        lines.push('');
      }

      // Certifications
      if (formData.certifications && formData.certifications.length > 0) {
        lines.push('CERTIFICATIONS');
        lines.push('-'.repeat(40));
        formData.certifications.forEach((cert) => {
          lines.push(`• ${cert.name || ''} - ${cert.issuer || ''} (${cert.year || ''})`);
        });
        lines.push('');
      }

      // Cover Letter
      if (coverLetterData?.body) {
        lines.push('');
        lines.push('COVER LETTER');
        lines.push('-'.repeat(40));
        lines.push(coverLetterData.body);
      }

      const text = lines.join('\n');
      const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${formData.full_name || 'resume'}_${new Date().toISOString().split('T')[0]}.txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      toast.success('✅ TXT downloaded successfully!');
    } catch (error) {
      console.error('TXT download error:', error);
      toast.error('Failed to download TXT.');
    }
    setLoading(false);
  };

  return (
    <Button
      onClick={handleDownload}
      disabled={loading}
      className="btn-hero-primary d-flex align-items-center gap-2 px-4 py-2"
    >
      <Download size={18} />
      <span>{loading ? 'Generating...' : 'Download TXT'}</span>
    </Button>
  );
};

export default TXTDownload;